import { useTranslation } from "react-i18next";

import { OpportunityHubActionBar } from "../PersonaOpportunityHubChrome/OpportunityHubActionBar.js";

export type OpportunityHubSetNextTab = "opportunities" | "scripts";

export interface OpportunityHubSetActionsProps {
  selectedIds: string[];
  /** Custom sets hold only scripts and orders, so a custom-only selection skips Opportunities. */
  nextTab: OpportunityHubSetNextTab;
  onClearSelection: () => void;
  onGoTo: (tab: OpportunityHubSetNextTab) => void;
}

/** Selection fly-in for the hub Sets tab. */
export function OpportunityHubSetActions({
  selectedIds,
  nextTab,
  onClearSelection,
  onGoTo,
}: OpportunityHubSetActionsProps) {
  const { t } = useTranslation();
  const selectedCount = selectedIds.length;
  const goToAction =
    nextTab === "scripts"
      ? {
          id: "go-to-scripts",
          label: t("personaOpportunities.tabs.goToScriptsAndBriefs", "Go to Scripts & Briefs"),
          testId: "opportunity-hub-go-to-scripts",
        }
      : {
          id: "go-to-opportunities",
          label: t("personaOpportunities.tabs.goToOpportunities", "Go to Opportunities"),
          testId: "opportunity-hub-go-to-opportunities",
        };

  return (
    <OpportunityHubActionBar
      selectedCount={selectedCount}
      selectedLabel={t("personaOpportunities.hub.bulk.setsSelected", {
        count: selectedCount,
        defaultValue_one: "{{count}} set selected",
        defaultValue_other: "{{count}} sets selected",
      })}
      onClearSelection={onClearSelection}
      ariaLabel={t("personaOpportunities.hub.bulk.setsBarAria", {
        count: selectedCount,
        defaultValue_one: "Bulk actions for {{count}} selected set",
        defaultValue_other: "Bulk actions for {{count}} selected sets",
      })}
      testId="opportunity-hub-set-bar"
      actions={[{ ...goToAction, icon: "arrow-right", onClick: () => onGoTo(nextTab) }]}
    />
  );
}
